import { useEffect, useCallback } from "react";
import { useLocalStorage } from "./local-storage";

// Array of API discovery doc URLs for APIs used by the quickstart
var DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/people/v1/rest",
];

// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
var SCOPES = "https://www.googleapis.com/auth/contacts.readonly";

const prepareContacts = (contacts) =>
  contacts
    .map((ct) => ({
      ...ct,
      phoneNumbers:
        ct.phoneNumbers &&
        ct.phoneNumbers.map((number) => number.canonicalForm).filter(Boolean),
    }))
    .filter((ct) => ct.names && ct.phoneNumbers && ct.phoneNumbers.length);

function initClient(gapi, setSigninStatus) {
  console.log("initClient");
  gapi.client
    .init({
      apiKey: "AIzaSyBb9ixNQV1oLMI4c7HTyhtSpMYwJKzKd9E",
      clientId:
        "1022946711972-jeuqgqa05mjbbpa1essnnmhvl9c88bu8.apps.googleusercontent.com",
      discoveryDocs: DISCOVERY_DOCS,
      scope: SCOPES,
    })
    .then(function () {
      console.log("initClient then");
      // Listen for sign-in state changes.
      gapi.auth2
        .getAuthInstance()
        .isSignedIn.listen((status) => setSigninStatus(status));
      const status = gapi.auth2.getAuthInstance().isSignedIn.get();
      console.log("status ", status);
      console.log("window.gapi ", window.gapi);
      setSigninStatus(status);
    })
    .catch(function (error) {
      console.error(error);
    });
}

const loadClient = (handleClientLoad) => {
  const jsSrc = "https://apis.google.com/js/api.js";
  ((d, s, id, cb) => {
    const element = d.getElementsByTagName(s)[0];
    const fjs = element;
    let js = element;
    js = d.createElement(s);
    js.id = id;
    js.src = jsSrc;
    if (fjs && fjs.parentNode) {
      fjs.parentNode.insertBefore(js, fjs);
    } else {
      d.head.appendChild(js);
    }
    js.onload = () => handleClientLoad();
    js.onreadystatechange = function () {
      if (this.readyState === "complete") handleClientLoad();
    };
  })(document, "script", "google-contacts");
};

const gapiLoad = (setSigninStatus) => {
  const handleClientLoad = () => {
    console.log("handleClientLoad");
    window.gapi.load("client:auth2", () =>
      initClient(window.gapi, setSigninStatus)
    );
  };

  loadClient(handleClientLoad);
};

export const useGoogleAPI = () => {
  const [{ signinStatus, contacts, nextPageToken }, setState] = useLocalStorage(
    "useGoogleAPI",
    {
      signinStatus: false,
      contacts: [],
      nextPageToken: null,
    }
  );
  const setSigninStatus = useCallback(
    (signinStatus) => setState((s) => ({ ...s, signinStatus })),
    [setState]
  );
  const setContacts = useCallback(
    (contacts, nextPageToken) =>
      setState((s) => ({ ...s, contacts, nextPageToken })),
    [setState]
  );

  useEffect(() => {
    gapiLoad(setSigninStatus);
  }, [setSigninStatus]);

  const fetchContacts = () => {
    const fetchAll = async () => {
      if (!window.gapi) return;
      console.log(window.gapi.client.people.people.connections);
      const connections = window.gapi.client.people.people.connections;
      const list = await connections.list({
        resourceName: "people/me",
        pageSize: 100,
        personFields: "names,emailAddresses,phoneNumbers",
        pageToken: nextPageToken,
      });

      setContacts(
        contacts.concat(prepareContacts(list.result.connections)),
        list.result.nextPageToken
      );
    };
    if (signinStatus && (nextPageToken || nextPageToken === null)) {
      fetchAll();
    }
  };
  useEffect(() => {
    gapiLoad(setSigninStatus);
    console.log("signinStatus : " + signinStatus);
    console.log("contacts : " + contacts);
    console.log("nextPageToken : " + nextPageToken);
    console.log("setContacts : " + setContacts);
    fetchContacts();
  }, [signinStatus, contacts, nextPageToken, setContacts]);

  function auth(event) {
    window.gapi.auth2
      .getAuthInstance()
      .signIn()
      .then(() => {})
      .catch((err) => console.log(err));

    fetchContacts();
  }

  /**
   *  Sign out the user upon button click.
   */
  function signout(event) {
    window.gapi.auth2.getAuthInstance().signOut();
  }

  return {
    signinStatus,
    gapi: window.gapi,
    contacts,
    auth,
    signout,
  };
};
